import classNames from 'classnames';
import React from 'react';

import { useAppDispatch } from 'js/store/hooks';
import { toggleSearchFilter } from 'js/actionCreators/imageSearchActions';
import useSearchFilters from 'js/shared/hooks/useSearchFilters';
import { ReactComponent as IconChevron } from 'imgs/svg-icons/IconDownChevron.svg';

import './FilterOption.css';

import FilterCheckbox from './FilterCheckbox';
import FilterCountBadge from './FilterCountBadge';

interface FilterOptionProps {
  title: string;
  options: Array<{
    name: string;
    slug: string;
    facetId: string;
    selected?: boolean;
    disabled?: boolean;
    disabledByVisualStyle?: boolean;
  }>;
  open: boolean;
  onClick?: () => void;
}

const FilterOption = ({ title, options, open, onClick }: FilterOptionProps) => {
  const dispatch = useAppDispatch();
  const { loading } = useSearchFilters();
  const drawerClasses = classNames('FilterOption__drawer', {
    'FilterOption__drawer--open': open
  });
  const buttonClasses = classNames('FilterOption__button', {
    'FilterOption__button--open': open
  });
  const selectedCount = options.filter(option => option.selected).length;
  let selectedCountText = '';
  if (selectedCount > 0) {
    selectedCountText = selectedCount > 9 ? '9+' : selectedCount.toString();
  }

  return (
    <div className="FilterOption">
      <div className="FilterOption__header">
        <button className={buttonClasses} onClick={onClick}>
          <span className="FilterOption__label">{title}</span>
          {!!selectedCountText && <FilterCountBadge>{selectedCountText}</FilterCountBadge>}

          <IconChevron className="FilterOption__buttonIcon" />
        </button>
      </div>
      <div className={drawerClasses}>
        <div className="FilterOption__drawerContent">
          {options.map(option => {
            const handleFilterChange = () => {
              if (loading) {
                return;
              }
              dispatch(
                toggleSearchFilter({
                  facetId: option.facetId,
                  facetValue: option.slug
                })
              );
            };

            return (
              <FilterCheckbox
                key={`${title}-${option.facetId}-${option.name}`}
                title={option.name}
                selected={option.selected}
                disabled={option.disabled || option.disabledByVisualStyle || loading}
                disabledByVisualStyle={option.disabledByVisualStyle}
                onChange={handleFilterChange}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterOption;
